export interface ProjectSortOption {
	isAscending: boolean;
	label: string;
	sortField: string;
}
